export default __webpack_public_path__ + "static/media/user_icon.acd6f909.svg";